import React, { useState } from "react";
import {
    Paper,
    Grid,
    Typography,
    Button,
    Popover,
    Box,
    IconButton,
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings"


const ScoringPopover = ({
    anchorEl,
    onClose,
    onScore,
    playerData,
    playerNumber,
    players,

}) => {
    const open = Boolean(anchorEl);

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
            <Box p={2} display="flex" flexDirection="column" alignItems="center">
                <Typography variant="h6">

                    {playerData?.name || "Sin nombre"} (#{playerNumber})
                </Typography>
                <Typography variant="body2">
                    Puntos: {playerData?.totalPuntos || 0} | Faltas: {playerData?.totalFaltas ? playerData.totalFaltas + "/5" : "0}/5"}
                </Typography>

                {(playerData.playing || playerData.number === "team") &&
                    <Box mt={2} mb={1}>
                        <Button
                            variant="contained"
                            onClick={() => onScore("1", playerNumber)}
                            style={{ margin: 4, fontSize: 18, padding: 2 }}
                        >
                            +1
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => onScore("2", playerNumber)}
                            style={{ margin: 4, fontSize: 18, padding: 2 }}
                        >
                            +2
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => onScore("3", playerNumber)}
                            style={{ margin: 4, fontSize: 18, padding: 2 }}
                        >
                            +3
                        </Button>
                    </Box>

                }
                {(playerData.playing || playerData.number === "team") &&

                    <Box mb={1}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => onScore("-1", playerNumber)}
                            disabled={playerData?.totalPuntos < 1}
                            style={{ margin: 4, fontSize: 18, padding: 2 }}
                        >
                            -1
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => onScore("-2", playerNumber)}
                            disabled={playerData?.totalPuntos < 2}
                            style={{ margin: 4, fontSize: 18, padding: 2 }}
                        >
                            -2
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => onScore("-3", playerNumber)}
                            disabled={playerData?.totalPuntos < 3}
                            style={{ margin: 4, fontSize: 18, padding: 2 }}
                        >
                            -3
                        </Button>
                    </Box>
                }
                {(playerData.playing || playerData.number === "team") &&

                    <Box>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => onScore("foul", playerNumber)}
                            style={{ margin: 4, fontSize: 15, padding: 5 }}
                        >
                            Falta
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => onScore("-foul", playerNumber)}
                            disabled={playerData?.totalFaltas < 1}
                            style={{ margin: 4, fontSize: 15, padding: 5 }}
                        >
                            Quitar Falta
                        </Button>
                    </Box>
                }
                {playerData.playing &&
                    <Box>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => onScore("cambiosale", playerNumber)}
                            style={{ margin: 4, fontSize: 15, padding: 5 }}
                        >
                            Sale de cancha
                        </Button>
                    </Box>
                }
                {!playerData.playing && players && players[playerData.teamKey] &&
                    <Box>
                        {Object.values(players[playerData.teamKey]).filter((a) => a.playing).map((a) =>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => onScore("cambio", playerNumber, a.number)}
                                style={{ margin: 4, fontSize: 18 }}
                            >
                                <Typography variant="subtitle1">
                                    Cambio por:
                                </Typography>

                                <Typography variant="h4">
                                    {a.number}
                                </Typography>
                            </Button>

                        )}
                        {players[playerData.teamKey].filter(p => p.playing === true).length < 5 &&
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => onScore("cambio", playerNumber, "NA")}
                                style={{ margin: 4, fontSize: 18, padding: 2 }}
                            >
                                Entra a Cancha
                            </Button>

                        }
                    </Box>
                }
            </Box>
        </Popover>
    );
};

const QuickScoringMobile = ({ teamA = {}, teamB = {}, teamAInfo, teamBInfo, onAction, openTeamConfig }) => {
    console.log("teamA", teamA);
    console.log("teamB", teamB);


    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);

    const handleClick = (event, team, index) => {
        console.log(team, index);
        setAnchorEl(event.currentTarget);
        setSelectedTeam(team);
        setSelectedIndex(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedTeam(null);
        setSelectedIndex(null);
    };

    const handleScore = (action, number, numberOut) => {
        if (onAction && selectedTeam !== null && selectedIndex !== null) {
            onAction(selectedTeam, selectedIndex, action, number, numberOut);
        }
        handleClose();
    };

    const getPlayerData = () => {
        const teamList = selectedTeam === "A" ? teamA : teamB;
        console.log(teamList, selectedIndex, teamList.filter((a) => selectedIndex === a.number))
        return teamList.filter((a) => selectedIndex === a.number)[0] || { name: "team", number: "team" };
    };

    const getPlayerNumber = () => {
        const player = getPlayerData();
        return player.number || selectedIndex + 1;
    };


    const withAlpha = (hex, alpha = 0.15) => {
        // hex tipo #RRGGBB
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const renderTeam = (teamName, players, teamKey, color) => (
        <Grid item xs={6}>
            <Grid container spacing={2} justify="center">
                <Grid item xs={12}>
                    <Typography onClick={(e) => handleClick(e, teamKey, "team")} variant="h4" align="center" gutterBottom style={{ fontWeight: 700, color: color }}>
                        {teamName} <IconButton onClick={() => openTeamConfig(teamKey)} >
                            <SettingsIcon />
                        </IconButton>

                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={2} justify="center">

                {players.sort((a, b) => b.playing - a.playing).map((p, i) => {

                    if (p.number === "team") {
                        return ""
                    }
                    return (

                        p.playing ?
                            <Grid xs={12} item key={i + " " + teamKey}>
                                <Button variant={p.playing ? "contained" : "outlined"}
                                    onClick={(e) => handleClick(e, teamKey, p.number)}
                                    style={{ width: "100%", height: 48, margin: 5, fontSize: 15, borderLeft: `10px solid ${color}`, backgroundColor: withAlpha(color, 0.2) }} >

                                    <Grid container spacing={2} justify="center">
                                        <Grid xs={2} item style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="h4" style={{
                                                backgroundColor: color,
                                                color: getContrastingColor(color),
                                                //borderRadius: 100,
                                                padding: "4px 10px",
                                                minWidth: 50,
                                                height: "100%",
                                                textAlign: "center"
                                            }}>
                                                {p.number || "SIN NÚMERO"}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={9} item style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="subtitle1">
                                                {p.name}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={1} item style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography variant="body2" style={{ fontSize: 11 }}>
                                                P:{p.totalPuntos} F:{p.totalFaltas}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Button>
                            </Grid> :
                            <Grid xs={6} item key={i}>
                                <Button variant={p.playing ? "contained" : "outlined"}
                                    onClick={(e) => handleClick(e, teamKey, p.number)}
                                    style={{ width: "100%", height: 48, margin: 5, fontSize: 25, borderLeft: `10px solid ${color}`, backgroundColor: withAlpha(color, 0.2) }} >

                                    <Typography variant="h4" style={{
                                        //backgroundColor: color,
                                        color: "#000000",//getContrastingColor(color),
                                        borderRadius: 100,
                                        padding: "4px 10px",
                                        minWidth: 48,
                                        textAlign: "center"
                                    }}>

                                        {p.number || "SIN NÚMERO"}
                                    </Typography>

                                </Button>
                            </Grid>
                    )
                })}
            </Grid >


        </Grid >
    );


    function getContrastingColor(hexColor) {
        if (!hexColor) return "black";

        // Quitar el símbolo #
        const hex = hexColor.replace("#", "");

        // Convertir a formato RGB
        const r = parseInt(hex.length === 3 ? hex[0] + hex[0] : hex.substr(0, 2), 16);
        const g = parseInt(hex.length === 3 ? hex[1] + hex[1] : hex.substr(2, 2), 16);
        const b = parseInt(hex.length === 3 ? hex[2] + hex[2] : hex.substr(4, 2), 16);

        // Calcular luminancia relativa (según el estándar W3C)
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        // Si es oscuro → blanco, si es claro → negro
        return luminance > 0.5 ? "black" : "white";
    }

    return (
        <Paper style={{ padding: 10 }}>
            <Grid container spacing={2}>
                {renderTeam(teamAInfo.name, teamA, "A", teamAInfo.teamColor || "#5c5c5c")}
                {renderTeam(teamBInfo.name, teamB, "B", teamBInfo.teamColor || "#000000")}
            </Grid>

            <ScoringPopover
                anchorEl={anchorEl}
                onClose={handleClose}
                onScore={handleScore}
                playerData={getPlayerData()}
                playerNumber={getPlayerNumber()}
                players={{ A: teamA, B: teamB }}
            />
        </Paper>
    );
};

export default QuickScoringMobile;
